import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { type IUserSession } from '@principle-theorem/ng-principle-shared';
import {
  PasswordSetForm,
  type IPasswordSet,
} from '../password-form/password-forms';

@Component({
  selector: 'pr-switch-user-dialog',
  templateUrl: './switch-user-dialog.component.html',
  styleUrls: ['./switch-user-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SwitchUserDialogComponent {
  form: PasswordSetForm = new PasswordSetForm();

  constructor(
    @Inject(MAT_DIALOG_DATA) public user: IUserSession,
    private _dialogRef: MatDialogRef<SwitchUserDialogComponent>
  ) {}

  submit(): void {
    if (this.form.invalid) {
      return;
    }
    const data: IPasswordSet = this.form.getRawValue();
    this._dialogRef.close(data.password);
  }
}
